import $ from 'jquery';
import MustacheComponent from '@components/mustache-component';
import UserRatesRepository from './repository';

import { scroller as loginBarScroller } from '@ui/login-bar/scroller';
import { siteModel } from 'models/SiteModel';

const $container = $('.article-content--rating-results');
const $configuration = $container.find('.rating-configuration');

const userAPI = $configuration.data('match-ratings-user-api');
const matchRatingId = $configuration.data('match-rating-id');

const repository = new UserRatesRepository({ endpoints: { user: userAPI } });

const load = () => {
    const promise = (resolve, reject) => {
        const authenticated = siteModel.isUserLogged();
        if (!authenticated) {
            return resolve(false);
        }

        repository
            .load(matchRatingId)
            .then(data => resolve(data))
            .catch(() => resolve(false));
    };

    return new Promise(promise);
};

const authenticate = () => {
    const authenticated = siteModel.isUserLogged();
    if (!authenticated) {
        loginBarScroller();
    }
    return authenticated;
};

const prepare = rating => {
    const stars = num => {
        if (!num) {
            return 0;
        }
        return num;
    };

    return {
        rating: String(rating.toFixed(1)).replace(/\./g, ','),
        stars: String(stars(rating)),
        isRated: stars(rating) > 0,
    };
};

const start = loaded => {
    $('.mustache-rating-vote').removeClass('is-loading');
    if (!loaded) {
        /*
         * leave default content (log in to make votes)
         */
        $('.mustache-rating-vote a').click((ev) => {
            ev.preventDefault();
            ev.stopPropagation();

            authenticate();
        });
        return;
    }

    const $widgets = $('.player-rating-card, .team-rating-card');
    const $template = $('#template-rating-vote');

    const mustache = new MustacheComponent($template);

    $widgets.each((i, o) => {
        const $widget = $(o);
        const $ajax = $widget.find('.mustache-rating-vote');
        const $show = $widget.find('.pcr-desktop');

        const type = $widget.data('type');
        const id = $widget.data('id');

        let rating = (loaded[type] || {})[id];
        rating = rating === void 0 ? 0 : Number(rating);

        mustache.set(prepare(rating));

        const html = mustache.render();
        $ajax.html(html);

        $show.removeClass('fn-hidden');
    });
};

export default {
    init() {
        $(document).ready(() => {
            if (!$container.length) {
                return;
            }

            load().then(data => {
                start(data);
            });
        });
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/user-rates/ratings.js